// Use server-based analytics instead of localStorage
import { analyticsServerService } from './analytics-server';

export const loadAnalyticsService = async () => {
  return analyticsServerService;
};
